<template>
	<on-click-outside :do="hideSlider">
		<div class="slider-picker">
			<p class="slider-picker-output" :class="{'active':sliderVisible}" @click="toggleSlider" :title="title">{{value}}%</p>

			<div v-if="sliderVisible" class="slider-picker-panel">
				<slider class="is-fullwidth is-circle is-info is-small" :step="step" :min="min" :max="max" :value="value" @input="changeSliderValue" type="range"></slider>
			</div>
		</div>
	</on-click-outside>
</template>
<script>
	import OnClickOutside from '@/components/common/OnClickOutside'
	import Slider from "./Slider";
	import _throttle from 'lodash.throttle'
	export default {
		components: {
			Slider,
			OnClickOutside
		},
		props: {
			title: String,
			min: Number,
			max: Number,
			step: Number,
			value: {
				type: Number,
				default() {
					return this.max;
				}
			}
		},
		data() {
			return {
				sliderVisible: false
			}
		},
		methods: {
			showSlider() {
				this.sliderVisible = true;
			},
			hideSlider() {
				this.sliderVisible = false;
			},
			toggleSlider() {
				this.sliderVisible = !this.sliderVisible;
			},
			changeSliderValue: _throttle(function throttleSliderValue(val) {				
				this.$emit('input', val);
			}, 300)
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	@import '../../assets/sass/main.scss';

	.slider-picker {
		position: relative;
	}

	.slider-picker-output {
		color: $grey-lighter;
	}

		.slider-picker-output.active, .slider-picker-output:hover {
			color: $grey;
		}

	/*.slider-picker-output.active {
			color: $grey;
		}*/

	.slider-picker-panel {
		display: flex;
		position: absolute;
		z-index: 33;
		right: 0;
		padding: 0 12px;
		background: #FFFFFF;
		border: 1px solid $grey-lighter;
		box-sizing: border-box;
		border-radius: 2px;
		width: 120px;
		height: 28px;
	}
</style>
